import { EAeroPhotoTourActionTypes } from '../../actions/aeroPhotoTour';
import { IAeroPhotoTourState } from '../../types/aeroPhoto';
import { TReduxActions } from '../../types/redux';

const initialState: IAeroPhotoTourState = {
  backgroundImage: null,
  isModalOpen: false,
};

export function aeroPhotoTourReducer(
  state: IAeroPhotoTourState = initialState,
  action: TReduxActions,
): IAeroPhotoTourState {
  switch (action.type) {
    case EAeroPhotoTourActionTypes.OpenModal:
      return {
        ...state,
        isModalOpen: true,
      };

    case EAeroPhotoTourActionTypes.CloseModal:
      return {
        ...state,
        isModalOpen: false,
      };

    default:
      return state;
  }
}
